module.exports = {
	"data": {
		"0C00004JD2": [
			"is_po_p"
		],
		"0C00000BO5": [
			"is_po_c",
			"is_pp_c"
		],
		"0C000016E0": [
			"is_po_c"
		],
		"0C00000Y1U": [
			"is_po_p",
			"is_sy_p"
		],
		"0C00003C57": [
			"is_po_p"
		],
		"0C00000Y80": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000Y1I": [
			"is_po_p"
		],
		"0C00000Y88": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000AEB": [
			"is_po_p",
			"is_sy_p",
			"is_po_c",
			"is_sy_c"
		],
		"0C000008P2": [
			"is_pp_c"
		],
		"0C00003ALL": [
			"is_po_p",
			"is_rb_p"
		],
		"0C00000FOT": [
			"is_pp_p",
			"is_tb_p"
		],
		"0C000017O5": [
			"is_sy_p"
		],
		"0C00003ALY": [
			"is_tb_p"
		],
		"0C00000GXI": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000FON": [
			"is_pp_c",
			"is_tb_c",
			"is_bf_c"
		],
		"0C000018DK": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000AJ1": [
			"is_po_c",
			"is_pp_c"
		],
		"0C0000A4B0": [
			"is_po_p"
		],
		"0C00000XD6": [
			"is_df_f"
		],
		"0C00003BJL": [
			"is_po_p"
		],
		"0C00000O38": [
			"is_po_p",
			"is_rb_p"
		],
		"0C000017OE": [
			"is_tb_p"
		],
		"0C000017OB": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000Y8G": [
			"is_po_p",
			"is_pp_p",
			"is_rb_p",
			"is_tb_p"
		],
		"0C00000Y8P": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00003AEC": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000015OQ": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00003C5D": [
			"is_po_p",
			"is_tb_p"
		],
		"0C00003C5E": [
			"is_po_p",
			"is_tb_p"
		],
		"0C00003C5A": [
			"is_po_p",
			"is_tb_p"
		],
		"0C00000XVD": [
			"is_df_f"
		],
		"0C00000LPM": [
			"is_rb_p",
			"is_tb_p",
			"is_df_f"
		],
		"0C00000AXM": [
			"is_df_f"
		],
		"0C00000XVP": [
			"is_po_p",
			"is_pp_p",
			"is_rb_p",
			"is_tb_p",
			"is_po_c",
			"is_pp_c"
		],
		"0C00002BDX": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000CTF": [
			"is_po_c"
		],
		"0C00000CTG": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000007IQ": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000UOX": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000UOO": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000008TX": [
			"is_pp_p",
			"is_pp_c"
		],
		"0C00002B00": [
			"is_pp_c",
			"is_tb_c",
			"is_bf_c"
		],
		"0C0000B9XS": [
			"is_po_c",
			"is_sy_c"
		],
		"0C0000ASGH": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000Y6S": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000ASO": [
			"is_bf_p",
			"is_sy_p"
		],
		"0C00000ASH": [
			"is_df_f"
		],
		"0C00000LYH": [
			"is_po_c"
		],
		"0C00000P8V": [
			"is_po_p"
		],
		"0C00000G6E": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000E4U": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00009EVV": [
			"is_po_p"
		],
		"0C000035X9": [
			"is_po_p",
			"is_rb_p"
		],
		"0C00000VLA": [
			"is_tb_p"
		],
		"0C00003GKL": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C00000BJN": [
			"is_pp_p"
		],
		"0C00008HZ6": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00002BQL": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000009PY": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000056RS": [
			"is_po_p"
		],
		"0C00000VC1": [
			"is_tb_p"
		],
		"0C00003BVR": [
			"is_df_f"
		],
		"0C000008JP": [
			"is_po_p"
		],
		"0C00003BVA": [
			"is_po_p"
		],
		"0C000007BH": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00009AO6": [
			"is_po_p"
		],
		"0C00003ALU": [
			"is_po_p",
			"is_pp_p",
			"is_sy_p"
		],
		"0C00000FNV": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000UTO": [
			"is_pp_c"
		],
		"0C000035XA": [
			"is_po_p",
			"is_rb_p"
		],
		"0C00000XXX": [
			"is_po_p",
			"is_rb_p",
			"is_tb_p"
		],
		"0C00000XXZ": [
			"is_df_f"
		],
		"0C00000BC7": [
			"is_df_f"
		],
		"0C000008FY": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000008FX": [
			"is_df_f"
		],
		"0C000095ED": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000NYY": [
			"is_po_p"
		],
		"0C00000XC7": [
			"is_po_p"
		],
		"0C000009NT": [
			"is_df_f"
		],
		"0C000007U5": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00002DDZ": [
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003ASZ": [
			"is_pp_p"
		],
		"0C00003ASH": [
			"is_po_p",
			"is_rb_p"
		],
		"0C0000AO13": [
			"is_bf_p",
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003AS6": [
			"is_tb_p"
		],
		"0C00000OOL": [
			"is_tb_p"
		],
		"0C000055F7": [
			"is_po_p",
			"is_pp_p"
		],
		"0C000009IA": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000AKL": [
			"is_po_c",
			"is_sy_c"
		],
		"0C00003N64": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000P4C": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C00002B6H": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000VZU": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000VZW": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00002BXU": [
			"is_tb_p",
			"is_pp_c",
			"is_tb_c"
		],
		"0C00000BGZ": [
			"is_df_f"
		],
		"0C0000B2H0": [
			"is_po_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000017G0": [
			"is_sy_p"
		],
		"0C00000BGB": [
			"is_pp_c",
			"is_tb_c",
			"is_bf_c"
		],
		"0C00003BKY": [
			"is_po_p"
		],
		"0C00000CD6": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00003C4S": [
			"is_po_p"
		],
		"0C00005129": [
			"is_po_c",
			"is_sy_c"
		],
		"0C00003C4V": [
			"is_df_f"
		],
		"0C00003C6H": [
			"is_po_p"
		],
		"0C00001505": [
			"is_sy_p",
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003C4X": [
			"is_po_p"
		],
		"0C000008A4": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003BLK": [
			"is_po_p"
		],
		"0C00003C4H": [
			"is_po_p",
			"is_tb_c"
		],
		"0C00003BLL": [
			"is_po_c"
		],
		"0C0000ASTJ": [
			"is_po_p"
		],
		"0C00000CQI": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000Q49": [
			"is_po_p"
		],
		"0C000016ZL": [
			"is_po_p",
			"is_sy_p",
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000D28": [
			"is_df_f"
		],
		"0C00003BK3": [
			"is_po_c",
			"is_pp_c",
			"is_rb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000008HA": [
			"is_df_f"
		],
		"0C00000C5L": [
			"is_pp_c"
		],
		"0C00008Q21": [
			"is_po_p",
			"is_sy_p"
		],
		"0C00000V41": [
			"is_po_p"
		],
		"0C00003AO4": [
			"is_df_f"
		],
		"0C0000B9P9": [
			"is_rb_p"
		],
		"0C00000Y7T": [
			"is_pp_p"
		],
		"0C00003H3H": [
			"is_po_p"
		],
		"0C00000B6K": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000095S3": [
			"is_po_p"
		],
		"0C00000GRG": [
			"is_df_f"
		],
		"0C00000PAI": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C00003C9N": [
			"is_rb_p"
		],
		"0C000006UX": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000XNT": [
			"is_pp_p"
		],
		"0C00003CHC": [
			"is_po_p"
		],
		"0C00006ISO": [
			"is_rb_p"
		],
		"0C00003CHM": [
			"is_po_p"
		],
		"0C00000VOS": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000AP3": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000016RK": [
			"is_po_c",
			"is_sy_c"
		],
		"0C00000XN1": [
			"is_po_p",
			"is_sy_p"
		],
		"0C00002BUQ": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00003COR": [
			"is_po_p"
		],
		"0C00000BUB": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00003COQ": [
			"is_po_p"
		],
		"0C00008TKT": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00003COU": [
			"is_po_p"
		],
		"0C0000BCKF": [
			"is_po_p",
			"is_sy_p",
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C0000AOT5": [
			"is_po_p"
		],
		"0C00000WW7": [
			"is_po_p"
		],
		"0C00000Y70": [
			"is_pp_p",
			"is_tb_p",
			"is_pp_c",
			"is_tb_c"
		],
		"0C00002AZ4": [
			"is_po_c"
		],
		"0C00003BWT": [
			"is_po_p"
		],
		"0C00000NC8": [
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003BWO": [
			"is_po_p"
		],
		"0C00000NC0": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C000014WC": [
			"is_po_p"
		],
		"0C00000Q0R": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C0000095Q": [
			"is_pp_c"
		],
		"0C0000BBPS": [
			"is_pp_c"
		],
		"0C00000XIO": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000014W8": [
			"is_rb_p"
		],
		"0C00000XIE": [
			"is_tb_c"
		],
		"0C0000B5MB": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000035IF": [
			"is_po_p",
			"is_tb_p"
		],
		"0C000008LL": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000GLO": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000E2B": [
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000OHG": [
			"is_df_f"
		],
		"0C00000B5G": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000OHJ": [
			"is_df_f"
		],
		"0C00003GQE": [
			"is_pp_p"
		],
		"0C00003CKT": [
			"is_tb_p",
			"is_tb_c"
		],
		"0C00000OHZ": [
			"is_pp_p"
		],
		"0C00000ALZ": [
			"is_po_c"
		],
		"0C00003CBM": [
			"is_po_p"
		],
		"0C00008O49": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C0000AKJG": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003C08": [
			"is_tb_p"
		],
		"0C00009E2G": [
			"is_po_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000AL0": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000017MI": [
			"is_bf_p",
			"is_sy_p",
			"is_bf_c",
			"is_sy_c"
		],
		"0C0000697O": [
			"is_pp_p",
			"is_tb_p"
		],
		"0C00000BBV": [
			"is_bf_p",
			"is_sy_p",
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000BP2": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000007DF": [
			"is_df_f"
		],
		"0C00000D8G": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00003AKL": [
			"is_po_p",
			"is_tb_p"
		],
		"0C00000D8B": [
			"is_df_f"
		],
		"0C00003AKB": [
			"is_po_p"
		],
		"0C00003AKD": [
			"is_po_p"
		],
		"0C00003AKE": [
			"is_po_p",
			"is_rb_p"
		],
		"0C00003CD6": [
			"is_po_p"
		],
		"0C00003BZ2": [
			"is_po_p"
		],
		"0C00003AR0": [
			"is_po_p"
		],
		"0C0000082B": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00009D2W": [
			"is_po_c"
		],
		"0C00000CI7": [
			"is_po_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000AZT": [
			"is_po_c"
		],
		"0C00000AZR": [
			"is_po_c"
		],
		"0C00000AZX": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000006U3": [
			"is_df_f"
		],
		"0C00000FXV": [
			"is_po_p",
			"is_po_c",
			"is_bf_c"
		],
		"0C00000UIW": [
			"is_po_c",
			"is_pp_c"
		],
		"0C0000A4YO": [
			"is_po_p"
		],
		"0C00000GKX": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C000017FE": [
			"is_bf_p",
			"is_sy_p"
		],
		"0C00000GWW": [
			"is_pp_c"
		],
		"0C00003AU6": [
			"is_po_p"
		],
		"0C000009OV": [
			"is_tb_c"
		],
		"0C00003EEF": [
			"is_po_p"
		],
		"0C00003EED": [
			"is_po_p"
		],
		"0C0000166G": [
			"is_po_p",
			"is_pp_p",
			"is_tb_p",
			"is_sy_p",
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_sy_c"
		],
		"0C00003BZZ": [
			"is_po_p",
			"is_rb_p"
		],
		"0C00000CIT": [
			"is_po_c",
			"is_pp_c",
			"is_rb_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000AUE": [
			"is_po_c"
		],
		"0C00000L3L": [
			"is_df_f"
		],
		"0C00003BZH": [
			"is_po_p"
		],
		"0C00000822": [
			"is_bf_c"
		],
		"0C000006UP": [
			"is_df_f"
		],
		"0C000055EE": [
			"is_po_c",
			"is_sy_c"
		],
		"0C000007YN": [
			"is_pp_c"
		],
		"0C00002JWR": [
			"is_df_f"
		],
		"0C00008FR5": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000BMS": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000BMT": [
			"is_df_f"
		],
		"0C00003BT9": [
			"is_po_p"
		],
		"0C00003DAP": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00003GUN": [
			"is_po_c"
		],
		"0C00000WM1": [
			"is_po_p",
			"is_rb_p"
		],
		"0C0000156A": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00004DB0": [
			"is_sy_p"
		],
		"0C00003BTU": [
			"is_df_f"
		],
		"0C000009RV": [
			"is_sy_c"
		],
		"0C0000B9Q2": [
			"is_tb_p"
		],
		"0C000017IC": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C00000YKD": [
			"is_pp_p"
		],
		"0C000009RZ": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003C3P": [
			"is_po_p"
		],
		"0C000014TF": [
			"is_df_f"
		],
		"0C00003C3F": [
			"is_po_p",
			"is_pp_p"
		],
		"0C00000VN7": [
			"is_df_f"
		],
		"0C00003C3L": [
			"is_po_p",
			"is_pp_p",
			"is_rb_p",
			"is_tb_p"
		],
		"0C00003C3M": [
			"is_po_p"
		],
		"0C00003C3K": [
			"is_po_p"
		],
		"0C00003AK9": [
			"is_pp_p"
		],
		"0C00003CE1": [
			"is_po_p"
		],
		"0C000038PB": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00004B1H": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00003AQQ": [
			"is_po_p"
		],
		"0C00000CVT": [
			"is_pp_p",
			"is_tb_p",
			"is_pp_c",
			"is_tb_c"
		],
		"0C00003AQE": [
			"is_po_p"
		],
		"0C00003AQC": [
			"is_df_f"
		],
		"0C0000336N": [
			"is_df_f"
		],
		"0C00003AK4": [
			"is_df_f"
		],
		"0C00000XFG": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000B0E": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000AHZ": [
			"is_df_f"
		],
		"0C000035H4": [
			"is_po_p"
		],
		"0C00000C6W": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00008QWB": [
			"is_po_c",
			"is_sy_c"
		],
		"0C00000GSL": [
			"is_pp_p",
			"is_tb_p"
		],
		"0C00009U16": [
			"is_rb_p"
		],
		"0C00000726": [
			"is_po_p",
			"is_pp_p",
			"is_sy_p",
			"is_po_c",
			"is_sy_c"
		],
		"0C000014Y3": [
			"is_df_f"
		],
		"0C00003CEU": [
			"is_tb_p"
		],
		"0C000017LZ": [
			"is_bf_p",
			"is_sy_p",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003D66": [
			"is_po_c",
			"is_sy_c"
		],
		"0C000008QT": [
			"is_pp_c"
		],
		"0C000017LT": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C00008UBL": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00008JX1": [
			"is_sy_p"
		],
		"0C00000Q6A": [
			"is_df_f"
		],
		"0C00002BSQ": [
			"is_rb_p"
		],
		"0C00000Q6J": [
			"is_po_p"
		],
		"0C00009UQZ": [
			"is_po_p"
		],
		"0C00003C6W": [
			"is_po_p",
			"is_tb_p"
		],
		"0C00003AJP": [
			"is_po_p"
		],
		"0C00000Q6S": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00002BSC": [
			"is_pp_c"
		],
		"0C00004HQT": [
			"is_po_p"
		],
		"0C00003AJC": [
			"is_po_p"
		],
		"0C00000UM1": [
			"is_pp_p",
			"is_tb_p"
		],
		"0C00003C69": [
			"is_po_c",
			"is_sy_c"
		],
		"0C00003C7H": [
			"is_po_p"
		],
		"0C00003C65": [
			"is_po_p"
		],
		"0C00003C67": [
			"is_po_p"
		],
		"0C00000Q62": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C0000152W": [
			"is_po_p"
		],
		"0C00000Q68": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C0000AUJ3": [
			"is_po_p"
		],
		"0C00000X07": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C000017L0": [
			"is_pp_p",
			"is_bf_p",
			"is_sy_p",
			"is_bf_c",
			"is_sy_c"
		],
		"0C0000092J": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C0000BA8Q": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000BA0": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000BB5": [
			"is_pp_c",
			"is_rb_c",
			"is_tb_c",
			"is_bf_c"
		],
		"0C00009CZO": [
			"is_po_p"
		],
		"0C00000ARG": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000009EB": [
			"is_po_c",
			"is_pp_c",
			"is_rb_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000006TP": [
			"is_df_f"
		],
		"0C00000OI2": [
			"is_tb_c"
		],
		"0C00000XBO": [
			"is_po_p"
		],
		"0C00003CJ1": [
			"is_po_p"
		],
		"0C00000VAN": [
			"is_po_p",
			"is_tb_p"
		],
		"0C00006IQE": [
			"is_rb_p"
		],
		"0C00000UXC": [
			"is_pp_c"
		],
		"0C0000A5B6": [
			"is_pp_c"
		],
		"0C00000OIS": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00006IQZ": [
			"is_rb_p"
		],
		"0C00008I13": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00003AMO": [
			"is_po_c"
		],
		"0C00000W0M": [
			"is_po_p",
			"is_rb_p"
		],
		"0C00000W0J": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00002BZL": [
			"is_pp_c"
		],
		"0C000009L0": [
			"is_po_c",
			"is_pp_c",
			"is_rb_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00008Q4W": [
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000CS9": [
			"is_bf_p",
			"is_sy_p",
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C000038M6": [
			"is_pp_p"
		],
		"0C000018U7": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000GI5": [
			"is_df_f"
		],
		"0C000008UQ": [
			"is_po_c",
			"is_sy_c"
		],
		"0C0000085J": [
			"is_rb_c",
			"is_tb_c",
			"is_bf_c"
		],
		"0C000008CA": [
			"is_pp_c"
		],
		"0C00000P74": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C0000085E": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00004IJY": [
			"is_po_c",
			"is_sy_c"
		],
		"0C00000UNP": [
			"is_pp_c"
		],
		"0C00003BU5": [
			"is_po_p"
		],
		"0C00003ATQ": [
			"is_pp_p",
			"is_tb_p"
		],
		"0C00008FJD": [
			"is_po_p",
			"is_pp_p"
		],
		"0C000008JD": [
			"is_df_f"
		],
		"0C00009DBD": [
			"is_pp_c",
			"is_rb_c",
			"is_bf_c"
		],
		"0C0000AJEN": [
			"is_po_p"
		],
		"0C000018GI": [
			"is_po_p"
		],
		"0C0000APSA": [
			"is_sy_p"
		],
		"0C00000CEM": [
			"is_pp_p",
			"is_tb_p",
			"is_pp_c",
			"is_tb_c"
		],
		"0C00000BRK": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00008T5T": [
			"is_po_p"
		],
		"0C000014NA": [
			"is_tb_p"
		],
		"0C00000FU1": [
			"is_pp_p",
			"is_rb_p",
			"is_tb_p"
		],
		"0C00003CDL": [
			"is_po_p"
		],
		"0C00000VM2": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C00000NZB": [
			"is_po_c",
			"is_pp_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003AQJ": [
			"is_po_p"
		],
		"0C00000N7Y": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00008VP6": [
			"is_df_f"
		],
		"0C000007ZQ": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000OED": [
			"is_sy_p",
			"is_sy_c"
		],
		"0C000014N3": [
			"is_po_p"
		],
		"0C00000LHD": [
			"is_df_f"
		],
		"0C000007ZZ": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C0000AYRE": [
			"is_rb_p",
			"is_tb_p"
		],
		"0C00000ESE": [
			"is_pp_c"
		],
		"0C00000ESH": [
			"is_pp_c",
			"is_tb_c"
		],
		"0C00000CE7": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000016AO": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000802": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003AP7": [
			"is_df_f"
		],
		"0C00003AP3": [
			"is_tb_p"
		],
		"0C00000NHM": [
			"is_po_p",
			"is_sy_p",
			"is_po_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00000H9A": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C0000093N": [
			"is_po_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00002AUH": [
			"is_po_p"
		],
		"0C00000OXN": [
			"is_rb_p"
		],
		"0C00000CN4": [
			"is_pp_c"
		],
		"0C00003DES": [
			"is_sy_p"
		],
		"0C0000BDAW": [
			"is_po_p",
			"is_rb_p"
		],
		"0C0000AWPQ": [
			"is_sy_p"
		],
		"0C00000UK6": [
			"is_po_c",
			"is_pp_c"
		],
		"0C00000CNY": [
			"is_pp_c",
			"is_tb_c",
			"is_bf_c"
		],
		"0C00000AWC": [
			"is_pp_c",
			"is_bf_c"
		],
		"0C000014Q2": [
			"is_po_p"
		],
		"0C0000B68D": [
			"is_po_p",
			"is_bf_p",
			"is_sy_p"
		],
		"0C0000B9MD": [
			"is_pp_c"
		],
		"0C00000NAD": [
			"is_po_p"
		],
		"0C00003APU": [
			"is_po_p"
		],
		"0C00000MGF": [
			"is_po_c",
			"is_pp_c",
			"is_tb_c",
			"is_bf_c",
			"is_sy_c"
		],
		"0C00003APJ": [
			"is_df_f"
		],
		"0C00000746": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00008N28": [
			"is_po_c",
			"is_pp_c",
			"is_sy_c"
		],
		"0C00000ENX": [
			"is_df_f"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/CompanySectors.json
// module id = 181
// module chunks = 0